module.exports = __webpack_public_path__ + "img/Divergancy.d4e82913.jpg";